module.exports = __webpack_public_path__ + "img/wayfinder-mobile-ar-view-en.308a1da1.png";